import script from "./BindCoupon.vue?vue&type=script&lang=ts&setup=true&name=StockList"
export * from "./BindCoupon.vue?vue&type=script&lang=ts&setup=true&name=StockList"

import "./BindCoupon.vue?vue&type=style&index=0&id=7c03c327&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c03c327"]])

export default __exports__